import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Features from "./pages/Features";
import Pricing from "./pages/Pricing";
import GpCalculator from "./pages/GpCalculator";
import Faq from "./pages/Faq";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import RefundPolicy from "./pages/RefundPolicy";
import NotFound from "./pages/NotFound";
import ScrollToTop from "./components/site/ScrollToTop";
import CookieBanner from "./components/site/CookieBanner";
import StickyCta from "./components/site/StickyCta";
import BackToTop from "./components/site/BackToTop";
import SEO from "./lib/SEO";
import { installClickTracking } from "./lib/tracking";

function App() {
  useEffect(() => { installClickTracking(); }, []);
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <SEO />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/features" element={<Features />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/bar-gp-calculator" element={<GpCalculator />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <StickyCta />
        <BackToTop />
        <CookieBanner />
      </BrowserRouter>
    </div>
  );
}

export default App;
